import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShowerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"shower"}/>
}
